import { CorvalTimeSpanUnit } from '../types';

export const DAYS = {
	MONDAY:    1,
	TUESDAY:   2,
	WEDNESDAY: 4,
	THURSDAY:  8,
	FRIDAY:    16,
	SATURDAY:  32,
	SUNDAY:    64,
	EVERYDAY:  127,
	MON_FRI:   31,
	SAT_SUN:   96,
};

export const RANGE = {
	SECOND: 1,
	MINUTE: 2,
	HOUR:   3,
	DAY:    4,
	WEEK:   5,
	MONTH:  6,
	YEAR:   7,
};

export enum TIME_UNITS {
	DAYS   = 'DAYS',
	WEEKS  = 'WEEKS',
	MONTHS = 'MONTHS',
	YEARS  = 'YEARS',
};
